export default "__VITE_ASSET__DU0KUW_B__"